import React from "react";

import ModalQuestionContainer from "./ModalQuestionContainer";

import "./Modal.scss";

export default class Modal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const profileQuestion = this.props.data.profile_question;

        profileQuestion
        && window.PlatformSDK.insertProfileSurvey(document.getElementById("entry-modal-profile-question"), profileQuestion);
    }

    render() {
        const {data, answers, isShown, handleAnswerChange, handleEnterRaffle, handleToggleModal} = this.props;
        const profileQuestion = this.props.data.profile_question;
        const showHideClassName = isShown ? 'entry-modal display-block' : 'entry-modal display-none';

        return (
            <div className={showHideClassName}>
                <div className="cl-modal-mask"></div>

                <div
                    tabIndex="-1"
                    className="cl-modal-wrap"
                    role="dialog"
                >
                    <div
                        role="document"
                        className="cl-modal"
                    >
                        <div className="cl-modal-content">
                            <button
                                aria-label="Close"
                                className="cl-modal-close"
                                onClick={handleToggleModal}
                            >
                                <span className="cl-modal-close-x"></span>
                            </button>

                            <div className="cl-modal-body">
                                <div className="entry-modal-title">Just one more thing</div>

                                <div className="cl-modal-options d-flex flex-column">
                                    {
                                        data.questions[0].type !== "none"
                                        && <ModalQuestionContainer
                                            type={data.questions[0].type}
                                            description={data.questions[0].description}
                                            options={data.questions[0].options}
                                            answer={answers[0].data}
                                            handleAnswerChange={e => handleAnswerChange(e, 0)}
                                        />
                                    }

                                    {
                                        data.questions[1].type !== "none"
                                        && <ModalQuestionContainer
                                            type={data.questions[1].type}
                                            description={data.questions[1].description}
                                            options={data.questions[1].options}
                                            answer={answers[1].data}
                                            handleAnswerChange={e => handleAnswerChange(e, 1)}
                                        />
                                    }

                                    {
                                        profileQuestion
                                        && <div
                                            className="entry-modal-question-container"
                                            id="entry-modal-profile-question"
                                        >
                                        </div>
                                    }

                                    <div
                                        className="cl-provider-button cl-submit-btn align-self-center"
                                        onClick={handleEnterRaffle}
                                    >
                                        Submit and enter drawing
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
